module.exports = __webpack_public_path__ + "img/square.0ed5d8e2.png";